import { type ValueOf } from '@/lib/utils/type'

import { type CASE_ARCHIVE_STATUS_MAP } from '../../../constants'
import type { CaseSearchItem } from '../../../types'

export enum SearchCasesSortKey {
  ID = 'id',
  NAME = 'name',
  EMAIL = 'email',
  UPDATED_AT = 'updatedAt',
  PROCESSING_DAYS = 'processingDays',
  APPLICATION_FILED_DATE = 'applicationFiledDate',
  NEXT_HEARING_DATE = 'nextHearingDate',
}

export interface ReqSearchCasesQuery {
  keyword?: string
  pageNumber?: number
  pageSize?: number
  path_id?: number
  asc?: boolean
  sort?: SearchCasesSortKey
  processingTime?: string[]
  processingTimeCondition?: FilterCondition
  tags?: string[]
  tagCondition?: FilterCondition
  caseTypes?: string[]
  status?: string[]
  assignees?: number[]
  assigneeCondition?: FilterCondition
  archiveStatus?: ValueOf<typeof CASE_ARCHIVE_STATUS_MAP>
  isEoir?: boolean
}

export interface ResSearchCasesQuery {
  cases: CaseSearchItem[] | null
  currentPage: number
  pageSize: number
  totalCount: number
  totalPages: number
}

export const FilterCondition = {
  and: 'and',
  or: 'or',
} as const
export type FilterCondition = 'and' | 'or'
